module.exports = __webpack_public_path__ + "img/84.2.TN.adf68699.png";